import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";
import { ensureClinicalClassOptions } from "@/lib/pharmacology/registerClinicalClasses";
import { PRIMARY_PATIENT_ID } from "@/lib/clinical/singlePatientMode";

ensureClinicalClassOptions();

export function usePatients() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["patients", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("patients")
        .select("*")
        .is("deleted_at", null)
        .eq("id", PRIMARY_PATIENT_ID)
        .order("full_name", { ascending: true });
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function usePatient(id?: string) {
  return useQuery({
    queryKey: ["patient", id],
    enabled: !!id && id === PRIMARY_PATIENT_ID,
    queryFn: async () => {
      const { data, error } = await supabase.from("patients").select("*").eq("id", id!).maybeSingle();
      if (error) throw error;
      return data;
    },
  });
}

export function useSubstances() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["substances", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("substances")
        .select("*")
        .order("name", { ascending: true });
      if (error) throw error;
      return data ?? [];
    },
  });
}
